import {EMPTY_INSPIRATION, FETCH_INSPIRATION, GET_INSPIRATION} from '../actions/actionTypes';

const INITIAL_STATE = { inspirations: [], inspiration: null };

export default function(state = INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_INSPIRATION + '_FULFILLED':
      return { ...state, inspirations: action.payload.data};

    case GET_INSPIRATION + '_FULFILLED':
      return { ...state, inspiration: action.payload.data};
    case EMPTY_INSPIRATION :
      return { ...state, inspiration: null};

    default:
      return state;
  }
}
